<template>
    <div class="kt-form__section" v-bind:value.sync="valor">
        <div class="row ">
            <div class="form-group col-md-6">
                <label for="busqueda-concesionario">Busca concesionario</label>
                <div class="kt-input-icon kt-input-icon--left">
                    <input type="text" class="form-control form-control-sm" placeholder="Quito" id="busqueda-concesionario" v-model="filtro" >
                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                        <span><i class="fa fa-search"></i></span>
                    </span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3"  >
                <div class="overflow-auto" style="height: 500px">
                    <b-list-group>
                        <b-list-group-item href="#" class="flex-column align-items-start negro" v-for="(item,index2) in filtrado" :key="index2" :active="item.id===elejido.id" v-on:click="seleccionado(item)"  :variant="!item.complete ? 'dark' : ''">
                            <div class="d-flex w-100 justify-content-between">
                                <h6 class="mb-1"><b>{{item.empresa}} {{item.nombre}}</b></h6>
                            </div>
                            <small>{{item.canton}} <span v-if="item.parroquia">-</span> {{item.parroquia}}</small>
                            <br>
                            <small>{{item.detalles}}</small>
                            <br>
                            <small>{{item.itemal}}</small>
                        </b-list-group-item>
                        <div class="d-flex w-100 justify-content-between text-muted" v-if="cargando">
                            <h6 class="mb-1">Cargando</h6>
                        </div>
                        <div v-else>
                            <div class="d-flex w-100 justify-content-between text-danger" v-if="filtrado.length===0">
                                <h6 class="mb-1">No existen resultados</h6>
                            </div>
                        </div>
                    </b-list-group>
                </div>
            </div>
            <div class="col-md-9">
                <gmap-map
                        :center="elejido.centro"
                        :zoom="elejido.acercamiento"
                        class="mapa"
                        :options="configuracionMap">
                    <gmap-cluster :gridSize="60">
                        <template v-for="(item,index) in filtrado">
                            <gmap-marker :key="index"  :position="{lat:item.lat,lng:item.lng}" v-if="item.complete" :clickable="true" :draggable="false" @click="seleccionado(item)" :icon="require('../assets/images/point.png')">
                                <gmap-info-window :opened="item.ver">
                                    <div class="text-center">
                                        <div class="">
                                            <h6 class="card-title">{{item.empresa}} {{item.nombre}}</h6>
                                            <div class="card-text">
                                                <p>{{item.canton}}</p>
                                                <p class="text-muted">{{item.detalles}}</p>
                                                <div class="row" v-if="item.dias">
                                                    <small class="col" v-for="(dia,numero) in item.dias" :key="numero">
                                                        {{dia.dia}}<br><span v-for="hora in dia.horas" :key="hora"> {{shora(hora)}}</span>
                                                    </small>
                                                </div>
                                            </div>
                                            <a :href="'//maps.google.com/maps?daddr='+item.lat+','+item.lng+'&ll=true'" target="_blank" class="btn btn-link">Google maps</a>
                                            <a :href="'https://waze.com/ul?ll='+item.lat+','+item.lng+'&z=10&navigate=yes'" target="_blank" class="btn btn-link">Waze</a>
                                        </div>
                                    </div>
                                </gmap-info-window>
                            </gmap-marker>
                        </template>
                    </gmap-cluster>
                </gmap-map>
            </div>
        </div>
    </div>
</template>

<script>
    import constantes from "@/constantes";
    import * as servicio from "@/servicios";
    export default {
        name: "kia-mapa",
        data:()=>({
            valor:{},
            configuracionMap:{
                mapTypeControl:false,
                mapTypeControlOptions:false,
                streetViewControl:false,
                styles:constantes.Constantes.mapaEstilos
            },
            actual:{lat:parseFloat(process.env.VUE_APP_PAIS_LAT), lng:parseFloat(process.env.VUE_APP_PAIS_LNG)},
            filtro:null,
            ver:false,
            lista:[],
            elejido:{
                centro:{lat:parseFloat(process.env.VUE_APP_PAIS_LAT), lng:parseFloat(process.env.VUE_APP_PAIS_LNG)},
                acercamiento:7,
                id:null,
            },
            cargando:true,

        }),
        props: ['value','provincia'],
        computed:{
            filtrado: function() {
                let self = this;
                var noFilter=self.lista.filter(x=>x.orden!=0);
                var noFilterPara=self.lista.filter(x=>x.orden==0);
                if (this.filtro === null){
                 var newInfo=   noFilterPara.sort((a, b) => {
                        if(a.distancia === b.distancia)
                            return a.distancia - b.distancia;
                        else
                            return a.distancia - b.distancia;
                    });
                    const array3 = [...noFilter , ...newInfo]

                    return array3
                }
                   
                return self.lista.filter(function (post) {
                    return post.nombre.toLowerCase().indexOf(self.filtro.toLowerCase()) !== -1 || post.canton.toLowerCase().indexOf(self.filtro.toLowerCase()) !== -1 || post.parroquia.toLowerCase().indexOf(self.filtro.toLowerCase()) !== -1 || post.empresa.toLowerCase().indexOf(self.filtro.toLowerCase()) !== -1 ;
                })
            }
        },
        methods:{
            /**
             * cambia de formato de hora
             * **/
            shora:function(valor){
                return this.$moment(valor, "HH:mm:ss").format("HH[h]mm");
            },
            /**
             * consulta al backend la lista de consecionarios
             * y serializa la informacion para el depliegue
             * **/
            consultar:function(){
                this.cargando=true;
                this.lista=[];
                servicio.agencias.agencias(this.provincia).then((response)=>{
                    console.error('response', response)
                    let vm=this;
                    response.data.map(function(item){
                        let dias=[];
                        if(item.dt5){
                            let vector=item.dt5.split(",");
                            vector.map(function(item2){
                                dias.push(
                                    {
                                        dia:item2.split(" ")[0],
                                        horas:(item2.split(" ")[1]).split("-"),
                                    }
                                )
                            });
                        }
                        if(item.elements[0] && item.elements[0].dt15){
                            vm.lista.push({
                                id:item.id,
                                empresa:item.dt4,
                                nombre:item.dt1,
                                direccion:item.elements[0].dt2,
                                detalles:item.elements[0].dt2+' '+item.elements[0].dt4+' '+item.elements[0].dt3,
                                tipo:item.elements[0].dt6,
                                pais:item.elements[0].dt7,
                                prov:item.elements[0].dt8,
                                canton:item.elements[0].dt10,
                                parroquia:item.elements[0].dt9 ? item.elements[0].dt9 : "",
                                barrio:item.elements[0].dt11,
                                itemal:item.elements[0].dt13,
                                horas:4,//item.dt6.split("-"),
                                dias:dias,
                                distancia:vm.calcularDistancia({lng:parseFloat(item.elements[0].dt15),lat:parseFloat(item.elements[0].dt14)},item),
                                centro:{lat:parseFloat(item.elements[0].dt14), lng:parseFloat(item.elements[0].dt15)},
                                acercamiento:16,
                                lng:parseFloat(item.elements[0].dt15),
                                lat:parseFloat(item.elements[0].dt14),
                                orden:item.ndt11,
                                ver:false,
                                original:item,
                                complete:true,
                            });
                        }else{
                            vm.lista.push({
                                id:item.id,
                                empresa:item.dt4,
                                nombre:item.dt1,
                                horas:4,
                                canton:item.elements[0].dt10 ? item.elements[0].dt10 : "",
                                parroquia:item.elements[0].dt9 ? item.elements[0].dt9 : "",
                                detalles:'Sin dirección o cooderndas configuradas',
                                dias:dias,
                                orden:item.ndt11,
                                acercamiento:16,
                                ver:false,
                                original:item,
                                complete:false,
                                distancia:0,
                            });
                        }
                    });
                    this.cargando=false;
                });
            },
            /**
             *  hasta la del punto
             * **/
            calcularDistancia:function(punto,item){
                if(item.dt4==="INDIANEGOCIOS S.A."){
                    return 0;
                }else{
                    try {
                        const google = window.google;
                        let puntoA = new google.maps.LatLng(this.actual.lat, this.actual.lng);
                        let puntoB = new google.maps.LatLng(punto.lat, punto.lng);
                        return google.maps.geometry.spherical.computeDistanceBetween(puntoB, puntoA);
                    } catch(error) {
                        return 0;
                    }
                }
            },
            /**
             * Consulta la poscicion actual del usuario
             * **/
            async poseActual(){
                if(navigator.geolocation){
                    let vm=this;
                    await navigator.geolocation.getCurrentPosition(
                        await function(position) {
                            vm.actual={lat:position.coords.latitude,lng:position.coords.longitude};
                        },
                        await function() {
                            //
                        }
                    );
                    vm.consultar();
                }
            },
            seleccionado:function(elemento){
                this.valor=elemento;
                this.$emit('input', elemento);
                if(elemento.complete){
                    this.elejido.acercamiento=16;
                    this.ocultarInfos();
                    elemento.ver=true;
                    this.elejido=elemento;
                    this.elejido.acercamiento=16;
                }
            },
            ocultarInfos:function(){
                this.lista.map(function(item){
                    item.ver=false;
                });
            }
        },
        created(){
            this.ocultarInfos();
        },
        mounted() {
            if(this.value.id)
                 this.seleccionado(this.value);
            this.poseActual()
        }
    }
</script>

<style scoped>
    .mapa{
        width: 100%;
        height: 500px;
    }
    .col-md-3,.col-md-9,.col-md-6{
        padding: 0px;
    }
    .overflow-auto::-webkit-scrollbar {
        width: 1em;
    }
    .overflow-auto::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    }
    .overflow-auto::-webkit-scrollbar-thumb {
        background-color: darkgrey;
        outline: 1px solid slategrey;
    }
    .negro{
        color: black !important;
    }
    .negro.active{
        color:white !important;
    }
</style>
